export function setupOptimizedScrollThrottle(obj = window) {
    let running = false;

    const throttle = function () {
        if (running) return;
        running = true;
        requestAnimationFrame(function () {
            obj.dispatchEvent(new CustomEvent('optimizedScroll'));
            running = false;
        });
    };

    obj.addEventListener('scroll', throttle);
}
